// extracted by mini-css-extract-plugin
export default {"title":"SectionContact_title__0Rd1U","content":"SectionContact_content__4bsdR","iconGroup":"SectionContact_iconGroup__e4QHq","icon":"SectionContact_icon__vb0W7"};